// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3014J","colMaxWidth":"Table_colMaxWidth__13Idh"};